// extracted by mini-css-extract-plugin
export default {"aspectDropdown":"Dropdown_aspectDropdown__GawPt","aspectArrow":"Dropdown_aspectArrow__yNoz-","popper":"Dropdown_popper__915FV","dropdownItem":"Dropdown_dropdownItem__aQdub"};